// extracted by css-extract-rspack-plugin
export default {"page":"cW0Q1","content":"LJpt1","header":"vmxe0","logo_link":"SO2qI","logoLink":"SO2qI","main":"wHVIK","back_link":"LPrqX","backLink":"LPrqX","section":"OJlOE","grid":"JvIAc"};